<template>
  <div id="app">
    <MusicPlayer />
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import MusicPlayer from '@/components/MusicPlayer.vue'

onMounted(() => {
  // 禁止页面缩放
  disablePageScale()
})

const disablePageScale = () => {
  // 1. 阻止手势缩放
  document.addEventListener('gesturestart', (e) => e.preventDefault())

  // 2. 阻止双指缩放
  document.addEventListener('touchmove', (e) => {
    if (e.touches.length > 1) {
      e.preventDefault()
    }
  }, { passive: false })

  // 3. 阻止双击缩放
  let lastTouchEnd = 0
  document.addEventListener('touchend', (e) => {
    const now = Date.now()
    if (now - lastTouchEnd <= 300) {
      e.preventDefault()
    }
    lastTouchEnd = now
  }, false)

  // 4. 针对 iOS 的额外处理
  document.documentElement.style.webkitTextSizeAdjust = '100%'

  // 5. 阻止键盘弹起时的缩放（针对输入框）
  document.querySelectorAll('input, textarea').forEach(el => {
    el.addEventListener('focus', () => {
      document.documentElement.style.webkitTextSizeAdjust = '100%'
    })
  })
}
</script>

<style>
#app {
  max-height: 812px; /* no-vw */
  max-width: 375px; /* no-vw */
  background-color: #ffffff;
}
body{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
/* 禁止 iOS 字体自动调整 */
* {
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -webkit-tap-highlight-color: transparent;
}

/* 禁止选中 */
body {
  -webkit-user-select: none;
  user-select: none;
}

/* 针对输入框允许选中 */
input, textarea {
  -webkit-user-select: auto;
  user-select: auto;
}

.container {
  padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
}

.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
}
</style>
